import restApiConnection from '@/services/api/providers/Connection'
import RestApiBase from '@/services/models/RestApiBase'
import workloadItemType from '@/types/responses/workloadItem'
import { AxiosResponse } from 'axios'
import UserSession from '@/services/models/UserSession'

export default class SelfWorkload extends RestApiBase {
  public static async get(
    work?: string,
    vehicleId?: number
  ): Promise<AxiosResponse<workloadItemType>> {
    return this.sync(
      'GetWorkloadItems' + (work ?? '') + '_' + (vehicleId ?? ''),
      this.getOwn,
      { work, vehicleId }
    )
  }

  public static getOwn = async (args: {
    work?: string
    vehicleId?: number
  }): Promise<AxiosResponse<workloadItemType>> => {
    const user_id = UserSession.getStoredUserId() ?? ''
    return restApiConnection.get('/workload_items', {
      params: {
        user_session_id: user_id,
        limit: 15,
        work: args.work,
        vehicle_id: args.vehicleId,
      },
      headers: {
        'Cache-Control': 'max-age=0',
      },
    })
  }
}
